import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'


const state = {
    feature: [],
    plan: ""
}

const getters = {
    feature: function (state) {
        return state.feature;
    },
    plan: function (state) {
        return state.plan;
    }
}

const mutations = {
    initialize(state) {
        state.feature = []
        state.plan = '';
    }
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('getAccountPlanFeatures')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    getAccountPlanFeatures({ commit, state }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.id) {
                let url = `/planFeatures/${fiifi.id}`;
                return api.get(url)
                    .then(data => {
                        let response = data.data.encrypt.success[0];
                        if (response.feature && response.feature.length > 0)
                            state.feature = response.feature;
                        else state.feature = [];
                        state.plan = response.plan ? response.plan : "";
                        return Promise.resolve(data.data.encrypt.success[0])
                    })
                    .catch(err => {
                        console.error(`Error during account plan feature fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    getWorkspacePlanFeatures({ commit, state }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            let url = `/get/workspace/planFeatures/${payload.workspace_id}`;
            return api.get(url)
                .then(data => {
                    let response = data.data.encrypt.success[0];
                    if (response.feature && response.feature.length > 0)
                        state.feature = response.feature;
                    else state.feature = [];
                    state.plan = response.plan ? response.plan : "";
                    return Promise.resolve(data.data.encrypt.success)
                })
                .catch(err => {
                    console.error(`Error during account plan feature fetch: ${err}`)
                    return Promise.reject(err)
                })

        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}